import { ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api/useRestMutation';

export const UPDATE_MISSION_CONTROL_FILTERS_API_URL = '/i/missionControl/updateFilters';

export type UpdateMissionControlFiltersMutationResponse = undefined;
export type UpdateMissionControlFiltersMutationBody = {
  datePreset: string;
  campaignLabelIds: number[];
  messageTypeIds: number[];
};

export const useUpdateMissionControlFiltersMutation = (
  options?: UseRestMutationOptions<UpdateMissionControlFiltersMutationResponse>,
) => {
  return useRestMutation<
    UpdateMissionControlFiltersMutationResponse,
    UpdateMissionControlFiltersMutationBody
  >(UPDATE_MISSION_CONTROL_FILTERS_API_URL, ApiMethod.post, options);
};
